import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "¿Qué documentos necesito para declarar impuestos?",
    a: "Identificación válida, Social Security o ITIN de todas las personas incluidas en la declaración, formularios W-2 y 1099 del año, comprobantes de deducciones (donaciones, gastos médicos, hipoteca, educación), y datos bancarios para depósito directo del reembolso. Puedes descargar nuestro checklist gratuito arriba para tener la lista completa.",
  },
  {
    q: "¿Qué es un ITIN y quién lo necesita?",
    a: "El ITIN (Individual Taxpayer Identification Number) es un número de identificación fiscal que emite el IRS a personas que necesitan cumplir con obligaciones tributarias en EE.UU. pero no califican para un Social Security Number. Es indispensable para extranjeros con ingresos en el país, cónyuges y dependientes que aparecen en declaraciones, y estudiantes o inversionistas extranjeros. Somos Certifying Acceptance Agent (CAA), así que podemos certificar tus documentos sin que tengas que enviarlos originales al IRS.",
  },
  {
    q: "¿Puedo abrir una LLC siendo extranjero?",
    a: "Sí. Un extranjero (con o sin visa) puede abrir una LLC en Florida y en la mayoría de estados de EE.UU. No se requiere ser ciudadano ni residente. Necesitas un ITIN o EIN para operar, una dirección en el estado de registro, y un agente registrado. Nosotros hacemos todo el proceso de principio a fin.",
  },
  {
    q: "¿Atienden virtualmente?",
    a: "Sí. Atendemos de forma presencial en Florida y también 100% virtual desde cualquier lugar de Estados Unidos. Ofrecemos notarización remota certificada (RON) para clientes fuera del área, videollamadas de consulta y firma de documentos por medios digitales cuando el trámite lo permite.",
  },
  {
    q: "¿Qué servicios notariales ofrecen?",
    a: "Como Notary Public certificada del estado de Florida, ofrecemos: notarizaciones presenciales y remotas (RON), poderes notariales (Power of Attorney), affidavits, declaraciones juradas, permisos de viaje para menores, certificación de firmas, copias certificadas y tramitación de apostillas. Trae identificación válida con foto para el acto notarial.",
  },
  {
    q: "¿Preparan formularios migratorios?",
    a: "Sí. Ofrecemos asistencia con el llenado de formularios USCIS (I-130, I-485, N-400, I-765, entre otros). Importante: no somos abogados y no brindamos asesoría ni representación legal migratoria. Nuestros servicios se limitan a la preparación y asistencia con los formularios conforme a la legislación aplicable. Para representación legal te podemos referir a un abogado de confianza.",
  },
  {
    q: "¿Cómo puedo solicitar una apostilla?",
    a: "Tramitamos apostillas para documentos que necesitas usar en países miembros de la Convención de La Haya (nacimiento, matrimonio, poderes, títulos académicos, etc.). El proceso: (1) traes o preparamos el documento base, (2) lo notarizamos o certificamos, (3) lo enviamos al Departamento de Estado de Florida o al Secretario de Estado correspondiente. El tiempo estimado es de 2 a 4 semanas.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 lg:py-32 bg-[#f8fafc]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center reveal">
          <div className="text-xs font-semibold text-[#0B2D5C] tracking-[0.2em] uppercase mb-4">
            Preguntas frecuentes
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f172a] leading-[1.1]">
            Resolvemos tus dudas antes{" "}
            <span className="text-[#0B2D5C]">de empezar</span>
          </h2>
          <p className="mt-5 text-lg text-[#475569] leading-relaxed max-w-2xl mx-auto">
            Las consultas más comunes que recibimos de personas, familias y pequeños negocios.
          </p>
        </div>

        <div className="mt-14 space-y-3">
          {FAQS.map((f, i) => (
            <div
              key={i}
              className="reveal bg-white border border-[#e2e8f0] rounded-sm overflow-hidden hover:border-[#C89B2C]/50 transition-colors"
              style={{ transitionDelay: `${i * 30}ms` }}
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between text-left p-6 group"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-display font-semibold text-[#0f172a] text-base sm:text-lg pr-4 group-hover:text-[#0B2D5C] transition-colors">
                  {f.q}
                </span>
                <ChevronDown
                  className={`text-[#0B2D5C] flex-shrink-0 transition-transform duration-300 ${
                    open === i ? "rotate-180" : ""
                  }`}
                  size={20}
                  strokeWidth={2}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  open === i ? "max-h-[600px]" : "max-h-0"
                }`}
              >
                <div className="px-6 pb-6 pt-0 text-[#475569] leading-relaxed border-t border-[#e2e8f0]">
                  <p className="pt-4">{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
